<template>
  <div class="otp-input-group">
    <input
      v-for="(digit, index) in otp"
      :key="index"
      type="text"
      class="otp-box"
      maxlength="1"
      :id="'otp-box-' + index"
      v-model="otp[index]"
      @input="handleInput($event, index)"
      @keydown.backspace="handleKeyDown($event, index)"
      @paste="handlePaste"
      ref="otpBoxes"
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      otp: ['', '', '', '', '', '']
    }
  },
  computed: {
    computedOtp() {
      return this.otp.join('')
    }
  },
	mounted() {
    this.$nextTick(() => {
      if (this.$refs.otpBoxes && this.$refs.otpBoxes.length > 0) {
        this.$refs.otpBoxes[0].focus();
      }
    });
  },
  methods: {
    handleInput(event, index) {
      const value = event.target.value;
      this.otp[index] = value.replace(/[^0-9]/g, '').substring(0, 1);

      if (this.otp[index] && index < this.otp.length - 1) {
        this.$nextTick(() => {
          this.$refs.otpBoxes[index + 1].focus();
        });
      } else if (this.otp[index] && index === this.otp.length - 1) {
        event.target.blur();
      }
    },
    handleKeyDown(event, index) {
      if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
        this.$nextTick(() => {
          this.$refs.otpBoxes[index - 1].focus();
        });
      }
    },
    handlePaste(event) {
      event.preventDefault();

      const pasteData = event.clipboardData.getData('text').trim();
      const filteredData = pasteData.replace(/[^0-9]/g, '').substring(0, this.otp.length);

      for (let i = 0; i < this.otp.length; i++) {
        this.$set(this.otp, i, filteredData[i] || '');
      }

      this.$nextTick(() => {
        const lastIndex = Math.min(filteredData.length - 1, this.otp.length - 1);
        if (lastIndex >= 0) {
          this.$refs.otpBoxes[lastIndex].focus();
        }
      });
    }
  },
  watch: {
    computedOtp() {
      this.$emit('otpTracker', this.computedOtp)
    }
  }
}
</script>

<style scoped>
.otp-input-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 25px;
}

.otp-box {
  width: 45px;
  height: 55px;
  font-size: 24px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box; /* Ensures padding and border are included in the element's total width and height */
}

.otp-box:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}
</style>
